"use strict";
var __importStar =
  (this && this.__importStar) ||
  function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null)
      for (var k in mod)
        if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
  };
Object.defineProperty(exports, "__esModule", { value: true });
const Yup = __importStar(require("yup"));
const IValidation_1 = require("./IValidation");
const helper_1 = require("./helper");
exports.dataJoinerSchema = Yup.object().shape({
  joinType: Yup.string().required("Join type is required"),
  leftData: Yup.string().required("Left input is required"),
  rightData: Yup.string().required("Right input is required"),
  leftNodeKey: Yup.array()
    .of(Yup.string())
    .min(0),
  rightNodeKey: Yup.array()
    .of(Yup.string())
    .min(0),
  matchKeys: Yup.array().of(
    Yup.object().shape({
      key1: Yup.string().required("Left option is required"),
      key2: Yup.string().required("Right option is required")
    })
  )
});
class DataJoinerNodeValidation {
  validate(node) {
    let data = node.getNodeData();
    return helper_1.isValid(
      [
        { schema: exports.dataJoinerSchema, data },
        { schema: IValidation_1.nodeSchema, data: node.serializeNode() }
      ],
      node.getNodeId()
    );
  }
}
exports.DataJoinerNodeValidation = DataJoinerNodeValidation;
//# sourceMappingURL=DataJoinerNodeValidation.js.map
